import type { TError } from '@onesource/schemas';
import { useMutation } from '@tanstack/react-query';

import axios from '../../axios';

export const useGetGcsDownloadUrl = () => {
  return useMutation<{ url: string }, TError, string>({
    mutationFn: async uploadId => {
      const res = await axios.get<{ url: string }>(`/community-hub/gcs-uploads/${uploadId}/download-url`);
      return res.data;
    },
  });
};
